import { call, put, takeLatest } from 'redux-saga/effects';
import callApi from 'utils/callApi';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_ORDERS_LINES_CLAIMS = 'FETCH_ORDERS_LINES_CLAIMS';
export const FETCH_ORDERS_LINES_CLAIMS_SUCCESS = 'FETCH_ORDERS_LINES_CLAIMS_SUCCESS';
export const FETCH_ORDERS_LINES_CLAIMS_FAIL = 'FETCH_ORDERS_LINES_CLAIMS_FAIL';

// Reducer
export default function orderLinesClaimsReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_ORDERS_LINES_CLAIMS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ORDERS_LINES_CLAIMS_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newOrderLine = dataItem['Order Line'].map((orderLineItem) => {
          const newClaim = orderLineItem['Claim Md Claim'].map((claimItem) => {
            const newClaimItem = payload.data.find(payloadItem => payloadItem.ID === claimItem.ID);
            if (newClaimItem) {
              return newClaimItem;
            }
            return claimItem;
          });
          return {
            ...orderLineItem,
            'Claim Md Claim': newClaim,
          };
        });

        return {
          ...dataItem,
          'Order Line': newOrderLine,
        };
      });
      return {
        ...state,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_ORDERS_LINES_CLAIMS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchOrdersLinesClaims(payload) {
  return { type: FETCH_ORDERS_LINES_CLAIMS, payload };
}

export function fetchOrdersLinesClaimsSuccess(payload) {
  return { type: FETCH_ORDERS_LINES_CLAIMS_SUCCESS, payload };
}

export function fetchOrdersLinesClaimsFail(payload) {
  return { type: FETCH_ORDERS_LINES_CLAIMS_FAIL, payload };
}

// Requests
export function requestSearchOrdersLinesClaims(payload) {
  return callApi('claim_md/claims/search/', 'POST', payload);
}

// Sagas
function* fetchOrdersLinesClaimsSaga(action) {
  const { triggerLoading, ...otherProps } = action.payload;
  try {
    const res = yield call(requestSearchOrdersLinesClaims, otherProps);
    yield put(fetchOrdersLinesClaimsSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchOrdersLinesClaimsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* ordersLinesClaimsSaga() {
  yield takeLatest(FETCH_ORDERS_LINES_CLAIMS, fetchOrdersLinesClaimsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/ordersLinesClaims.js